<template>
  <v-row class="timer px-0 pt-2 ma-0" justify="center">
    <v-col class="pa-0 ma-0" cols="12" lg="7">
      <v-row v-if="showTimer" class="pa-0 ma-0" justify="center">
        <v-col v-if="showDays" class="day">
          <v-row>
            <v-col cols="12" class="number">
              {{ $data[TIME_UNITS.DAYS] }}
            </v-col>
            <v-col cols="12" class="format">
              {{ wordString[TIME_UNITS.DAYS] }}
            </v-col>
          </v-row>
        </v-col>
        <v-col class="hour">
          <v-row>
            <v-col cols="12" class="number">
              {{ $data[TIME_UNITS.HOURS] }}
            </v-col>
            <v-col cols="12" class="format">
              {{ wordString[TIME_UNITS.HOURS] }}
            </v-col>
          </v-row>
        </v-col>
        <v-col class="min">
          <v-row>
            <v-col cols="12" class="number">
              {{ $data[TIME_UNITS.MINUTES] }}
            </v-col>
            <v-col cols="12" class="format">
              {{ wordString[TIME_UNITS.MINUTES] }}
            </v-col>
          </v-row>
        </v-col>
        <v-col class="sec">
          <v-row>
            <v-col cols="12" class="number">
              {{ $data[TIME_UNITS.SECONDS] }}
            </v-col>
            <v-col cols="12" class="format">
              {{ wordString[TIME_UNITS.SECONDS] }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="pa-0 ma-0 mt-2 text-center" justify="center">
        <v-col :class="statusClass">
          {{ message }}
        </v-col>
      </v-row>
    </v-col>
  </v-row>

</template>

<style scoped>
    .timer {
        font-size: 15px;
        color: #fff;
        text-align:center;
        margin-top: 10px;
        min-width: 270px;
    }
    .day, .hour, .min, .sec {
        font-size: 20px;
        display: inline-block;
        font-weight: 500;
        text-align: center;
        margin: 0 2px;
        width: 60px;
        padding: 0;
    }
    .format {
        font-weight: 300;
        font-size: 14px;
        opacity: 0.5;
        width: 60px;
        color: #3a3838;
        margin-top: 5px;
        padding: 0px;
    }
    .number {
        /* background: rgba(51, 51, 51, 0.53); */
        padding: 0 5px;
        border-radius: 5px;
        display: inline-block;
        width: 40px;
        text-align: center;
        color: #1565C0;
        margin-top: 5px;
        padding: 0px;
    }
    .message {
        font-size: 14px;
        font-weight: bold;
        margin-top: 5px;
        color: #292626;
     }

    .message.inprocess {
      color: #1565C0;
    }
</style>

<script>
  import { TIMER_STATUSES, TIME_UNITS } from '@/constants/business'

  export default {
    props: {
      startTime: String,
      endTime: String,
      now: Object,
      displayText: {
        type: Object,
        default: function () {
          return {
            [TIMER_STATUSES.EXPIRED]: 'Завершено',
            [TIMER_STATUSES.RUNNING]: 'В процессе',
            [TIMER_STATUSES.UPCOMING]: 'Не начато',
            [TIME_UNITS.DAYS]: 'дн',
            [TIME_UNITS.HOURS]: 'час',
            [TIME_UNITS.MINUTES]: 'мин',
            [TIME_UNITS.SECONDS]: 'сек'
          }
        }
      }
    },
    data () {
      return {
        TIME_UNITS,
        interval: '',
        statusType: '',
        message: '',
        [TIME_UNITS.DAYS]: '',
        [TIME_UNITS.MINUTES]: '',
        [TIME_UNITS.HOURS]: '',
        [TIME_UNITS.SECONDS]: ''
      }
    },
    computed: {
      wordString () {
        const words = {
          [TIMER_STATUSES.EXPIRED]: this.$t(this.displayText[TIMER_STATUSES.EXPIRED]),
          [TIMER_STATUSES.RUNNING]: this.$t(this.displayText[TIMER_STATUSES.RUNNING]),
          [TIMER_STATUSES.UPCOMING]: this.$t(this.displayText[TIMER_STATUSES.UPCOMING]),
          [TIME_UNITS.DAYS]: this.$t(this.displayText[TIME_UNITS.DAYS]),
          [TIME_UNITS.HOURS]: this.$t(this.displayText[TIME_UNITS.HOURS]),
          [TIME_UNITS.MINUTES]: this.$t(this.displayText[TIME_UNITS.MINUTES]),
          [TIME_UNITS.SECONDS]: this.$t(this.displayText[TIME_UNITS.SECONDS])
        }

        return words
      },
      showDays () {
        return this[TIME_UNITS.DAYS] && this[TIME_UNITS.DAYS] > 0
      },
      showTimer () {
        return this.statusType === TIMER_STATUSES.RUNNING ||
          this.statusType === TIMER_STATUSES.UPCOMING
      },
      statusClass () {
        return `message ${this.statusType === TIMER_STATUSES.RUNNING ? 'inprocess' : ''} pa-0 ma-0`
      }
    },
    watch: {
      now: {
        immediate: true,
        handler (newValue) {
          if (newValue) {
            this.setTimer()
          }
        }
      },
      endTime: {
        immediate: true,
        handler (newValue) {
          if (newValue) {
            this.setTimer()
          }
        }
      },
      statusType (newValue, oldValue) {
        if (newValue !== oldValue &&
          newValue === TIMER_STATUSES.EXPIRED) {
          this.$emit('finished')
        }
      }
    },
    beforeDestroy () {
      if (this.interval) {
        clearInterval(this.interval)
      }
    },
    methods: {
      setTimer: function () {
        const vm = this
        if (vm.interval) {
          clearInterval(vm.interval)
        }
        if (vm.startTime && vm.endTime) {
          const start = vm.$moment(vm.startTime).toDate().getTime()
          const end = vm.$moment(vm.endTime).toDate().getTime()
          // Update the count down every 1 second
          vm.timerCount(start, end)
          vm.interval = setInterval(() => {
            vm.timerCount(start, end)
          }, 1000)
        }
      },
      timerCount: function (start, end) {
        // Get todays date and time
        const now = this.now.toDate().getTime()

        // Find the distance between now an the count down date
        const distance = start - now
        const leftTime = end - now
        let statusType = ''
        if (distance < 0 && leftTime < 0) {
          clearInterval(this.interval)
          statusType = TIMER_STATUSES.EXPIRED
        } else if (distance < 0 && leftTime > 0) {
          this.calcTime(leftTime)
          statusType = TIMER_STATUSES.RUNNING
        } else if (distance > 0 && leftTime > 0) {
          this.calcTime(distance)
          statusType = TIMER_STATUSES.UPCOMING
        }

        if (this.statusType !== statusType) {
          this.message = this.wordString[statusType]
          this.statusType = statusType
        }
      },
      calcTime: function (dist) {
        // Time calculations for days, hours, minutes and seconds
        this[TIME_UNITS.DAYS] = Math.floor(dist / (1000 * 60 * 60 * 24))
        this[TIME_UNITS.HOURS] = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        this[TIME_UNITS.MINUTES] = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60))
        this[TIME_UNITS.SECONDS] = Math.floor((dist % (1000 * 60)) / 1000)
      }
    }
  }
</script>
